import { FunctionComponent } from "react";
import { IconProps } from "./IconProps";

const MoveIcon: FunctionComponent<IconProps> = ({
  size = 24,
  color,
  testID,
}) => (
  <svg
    width={size}
    height={size}
    color={color}
    data-testid={testID}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.42105 5.84211C9.20588 5.84211 9.84211 5.20588 9.84211 4.42105C9.84211 3.63623 9.20588 3 8.42105 3C7.63623 3 7 3.63623 7 4.42105C7 5.20588 7.63623 5.84211 8.42105 5.84211ZM8.42105 13.4211C9.20588 13.4211 9.84211 12.7848 9.84211 12C9.84211 11.2152 9.20588 10.5789 8.42105 10.5789C7.63623 10.5789 7 11.2152 7 12C7 12.7848 7.63623 13.4211 8.42105 13.4211ZM9.84211 19.5789C9.84211 20.3638 9.20588 21 8.42105 21C7.63623 21 7 20.3638 7 19.5789C7 18.7941 7.63623 18.1579 8.42105 18.1579C9.20588 18.1579 9.84211 18.7941 9.84211 19.5789ZM16 5.84211C16.7848 5.84211 17.4211 5.20588 17.4211 4.42105C17.4211 3.63623 16.7848 3 16 3C15.2152 3 14.5789 3.63623 14.5789 4.42105C14.5789 5.20588 15.2152 5.84211 16 5.84211ZM17.4211 12C17.4211 12.7848 16.7848 13.4211 16 13.4211C15.2152 13.4211 14.5789 12.7848 14.5789 12C14.5789 11.2152 15.2152 10.5789 16 10.5789C16.7848 10.5789 17.4211 11.2152 17.4211 12ZM16 21C16.7848 21 17.4211 20.3638 17.4211 19.5789C17.4211 18.7941 16.7848 18.1579 16 18.1579C15.2152 18.1579 14.5789 18.7941 14.5789 19.5789C14.5789 20.3638 15.2152 21 16 21Z"
      fill="currentColor"
    />
  </svg>
);

export { MoveIcon };
